<template>
  <div class="iframe-source">
    <iframe :src="path" v-if="ready" width="100%" height="500px" style="border: none;"> </iframe>
  </div>
</template>

<script>
export default {
  name: 'pdfBLock',
  props: {
    dataFile: {
      type: [String, Promise, Number],
    }
  },
  data () {
    return {
      ready: false,
      b: false,
    }
  },
  computed:{
    path: {
      get () {
        return window.location.origin+'/web/viewer.html?file='+this.dataFile
      }
    }
  },
  mounted () {
    this.ready = true 
  }
}
</script>

<style lang="scss" scoped>
  .iframe-source {
 /*    background: white;
    padding: 10px;
    border-radius: 6px;
    margin: 24px 0px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2); */
    iframe {
      height: 100%;
      position: absolute;
      width: 100%;
    }
  }
</style>